import question from './question'
export default question
